import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'

const Licensing = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={commonStyles.heading}>Licensing</h1>
      <div className={commonStyles.subheading}>
        When the time comes to commercially release a new track containing a sample, the artist will first need to obtain a sample license
      </div>
      <div className={commonStyles.textContent}>
        <div className={commonStyles.paragraph}>
          Through Tracklib&apos;s simple and automated platform, the artist will pay an upfront fee and agree to share a revenue percentage
          with the original rightsholders and artists, and also copyright revenue with the sampled writers and publishers
        </div>
        <div className={commonStyles.paragraph}>
          We will place your tracks in one of three categories, optimised to get the best revenue. How much the license costs, and the
          percentage of revenue or copyright shared will depend of the Tracklib category and length of the sample used
        </div>
      </div>
    </motion.div>
  )
}

export default Licensing
